/**
 * 区分 goalType（goals.goal_type）
 * 出典：仕様書 7 章（deals→case。C-23）
 */
export const GOAL_TYPE_VALUES = ['sales', 'activity', 'case', 'custom'] as const;

export type GoalType = (typeof GOAL_TYPE_VALUES)[number];

export const GOAL_TYPE_LABELS: Readonly<Record<GoalType, string>> = {
  sales: '売上',
  activity: '活動',
  case: '案件',
  custom: 'カスタム',
};
